export class FeatureFlagOptions {   
    enabled: boolean = false;
    redirectUrl: string = '';
    isBlocked: boolean = false;
    warningText: string = 'Voor deze functionaliteit is geen toegang verleend.';
}
